var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copybook-result2"},[_c('ul',_vm._l((_vm.paths.length),function(n){return _c('li',{staticClass:"svg",style:({background: ("url(/static/img/bg" + (_vm.options.types) + (_vm.options.color) + ".jpg)")}),domProps:{"innerHTML":_vm._s(_vm.getHtml(n - 1))}})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3a6a308b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/stroke/index.vue
// module id = null
// module chunks = 